const GEO_BLOCK_CACHE_KEY = 'sharesquare.geo-blocked'
const GEOFENCE_PREFLIGHT_PATH = '/geofence/preflight'
const MAINTENANCE_PATH = '/maintenance'
const REGION_BLOCKED_PATH = '/region-blocked'

const clearGeoBlockCache = () => {
  if (typeof sessionStorage === 'undefined') {
    return
  }

  try {
    sessionStorage.removeItem(GEO_BLOCK_CACHE_KEY)
  } catch (error) {
    console.warn('Unable to clear geo-block cache:', error)
  }
}

const writeGeoBlockCache = () => {
  if (typeof sessionStorage === 'undefined') {
    return
  }

  try {
    sessionStorage.setItem(GEO_BLOCK_CACHE_KEY, 'true')
  } catch (error) {
    console.warn('Unable to cache geo-block status:', error)
  }
}

const isLocalEnvironment = (app) =>
  app.$config.public.appENV === 'localhost' ||
  app.$config.public.appENV === 'development'

const checkGeofenceAccess = async (app) => {
  try {
    const response = await fetch(
      `${app.$config.public.baseSharesquareApi}${GEOFENCE_PREFLIGHT_PATH}`,
      {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )

    if (response.status === 403) {
      const data = await response.json().catch(() => null)

      if (data?.message === app.$config.public.geofenceForbiddenMessage) {
        writeGeoBlockCache()
        app.$auth.clearAuthData()
        app.$auth.clearCookie()

        return false
      }
    }

    if (response.ok) {
      clearGeoBlockCache()
    }
  } catch (error) {
    console.error('Geofence preflight error:', error)
  }

  return true
}

export default defineNuxtRouteMiddleware(async (to) => {
  const app = useNuxtApp()
  const isGuestRoute = to.path === '/login'

  if (to.path === MAINTENANCE_PATH || to.path === REGION_BLOCKED_PATH) {
    return true
  }

  const hasCookie = await app.$auth?.initialLogin()

  if (hasCookie) {
    const tenantName = app.$auth?.getTenantName()
    const profilePath = tenantName ? `${tenantName}/me` : 'me'

    try {
      const response = await fetch(
        `${app.$config.public.baseSharesquareApi}/${profilePath}`,
        {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            Authorization: app.$auth.getCookie(),
          },
        }
      )

      if (response.status === 403) {
        const data = await response.json().catch(() => null)

        if (data?.message === app.$config.public.geofenceForbiddenMessage) {
          writeGeoBlockCache()
          app.$auth.clearAuthData()
          app.$auth.clearCookie()

          return navigateTo(REGION_BLOCKED_PATH)
        }
      }

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`)
      }

      const data = await response.json()

      clearGeoBlockCache()

      if (!data.is_new_ben && !isLocalEnvironment(app)) {
        window.location.href = `${app.$config.public.legacyPortalUrl}`
      }
    } catch (error) {
      console.error('Fetch error:', error)
    }
  }

  if (!hasCookie) {
    const isAllowed = await checkGeofenceAccess(app)

    if (!isAllowed) {
      return navigateTo(REGION_BLOCKED_PATH)
    }

    if (isGuestRoute) {
      return true
    }
  }

  if (!hasCookie) {
    return navigateTo('/login', { replace: true })
  }

  return true
})
